import {
  SmallText,
  SmallTextBold,
  type TypographyColor,
} from '../../../data-display/typography/Typography'
import type { AdditionalTextType } from '../../lists/types'

export const AdditionalText = ({
  additionalText,
  color,
  bold,
}: {
  additionalText?: AdditionalTextType
  color?: TypographyColor
  bold?: boolean
}) => {
  if (!additionalText) {
    return null
  }

  if (typeof additionalText === 'string') {
    const Component = bold ? SmallTextBold : SmallText
    return <Component color={color}>{additionalText}</Component>
  }

  return additionalText
}
